import { render, staticRenderFns } from "./GlobalDetailHeader.vue?vue&type=template&id=9915b2c4&scoped=true"
import script from "./GlobalDetailHeader.vue?vue&type=script&lang=ts"
export * from "./GlobalDetailHeader.vue?vue&type=script&lang=ts"
import style0 from "./GlobalDetailHeader.vue?vue&type=style&index=0&id=9915b2c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9915b2c4",
  null
  
)

export default component.exports